import ContentStrapline from './containers/ContentStrapline'

export default ContentStrapline
